import React from 'react';
import { Modal, Button, Row, Col } from 'antd';
import moment from 'moment';

const ModalBox = ({ visible, data, onClose }) => {
    return (
        <Modal
            open={visible}
            title={<h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#335001' }}>More Details</h2>}
            onCancel={onClose}
            width={1000}
            footer={[
                <Button
                    key="close"
                    onClick={onClose}
                    className="btnPrimary"
                    type="primary"
                    style={{ padding: '20px 20px', backgroundColor: '#335001', color: '#FFF' }}
                >
                    Close
                </Button>
            ]}
        >
            {data ? (
                <Row gutter={[32, 24]}>
                    <Col md={12}>
                        {data.gs1Event.epcisBody.eventList[0].readPoint.id && <p><strong>Read Point ID: </strong>{data.gs1Event.epcisBody.eventList[0].readPoint.id}</p>}
                        {data.gs1Event.creationDate && <p><strong>Creation Date: </strong>{moment(data.gs1Event.creationDate).format('DD MMMM YYYY')}</p>}
                        {data.gs1Event.epcisBody.eventList[0].action && <p><strong>Action: </strong>{data.gs1Event.epcisBody.eventList[0].action}</p>}
                        {data.gs1Event.epcisBody.eventList[0].eventTime && <p><strong>Event Time: </strong>{moment(data.gs1Event.epcisBody.eventList[0].eventTime).format('DD MMMM YYYY')}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.sector && <p><strong>Sector: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.sector}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.certificationDate && <p><strong>Certification Time: </strong>{moment(data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.certificationDate).format('DD MMMM YYYY')}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.timestamp && <p><strong>Timestamp: </strong>{moment(data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.timestamp).format('DD MMMM YYYY')}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.countryOfOrigin && <p><strong>Country of Origin: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.countryOfOrigin}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.description && <p><strong>Description: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.description}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.eventCertified && <p><strong>Event Certified: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.eventCertified}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.finalDateCertification && <p><strong>Final Certification Time: </strong>{moment(data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.finalDateCertification).format('DD MMMM YYYY')}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.initialDateCertification && <p><strong>Initial Certification Time: </strong>{moment(data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.initialDateCertification).format('DD MMMM YYYY')}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.link && <p><strong>Link: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.link}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.parcelID && <p><strong>Parcel ID: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.parcelID}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.GTIN && <p><strong>GTIN: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.GTIN}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.lotNumber && <p><strong>Lot Number: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.lotNumber}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.producerCertified && <p><strong>Producer Certified: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.producerCertified}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.productType && <p><strong>Product Type: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.productType}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.type && <p><strong>Type: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.type}</p>}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.result && <p><strong>Result: </strong>{data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.result}</p>}
                    </Col>
                    <Col md={12}>
                        {data.gs1Event.epcisBody.eventList[0].ilmd.certificates && (
                            <>
                                <h3>CERTIFICATES</h3>
                                {data.gs1Event.epcisBody.eventList[0].ilmd.certificates.map((certificate, index) => (
                                    <p key={`certificate-${index}`}>{certificate.docName}</p>
                                ))}
                            </>
                        )}
                        {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.markers && (
                            <>
                                <h3>MARKERS</h3>
                                {data.gs1Event.epcisBody.eventList[0].ilmd.traceInfo.markers.map((marker, index) => (
                                    <div key={`${marker.id}-${index}`}>
                                        <p><strong>Classification Code: </strong>{marker.classificationCode}</p>
                                        <p><strong>Classification Score: </strong>{marker.classificationScore}</p>
                                        <p><strong>Declared As Code: </strong>{marker.declaredAsCode}</p>
                                        <p><strong>ID: </strong>{marker.id}</p>
                                        <p><strong>Status: </strong>{marker.status}</p>
                                        <p><strong>Type: </strong>{marker.type}</p>
                                        <hr/>
                                    </div>
                                ))}
                            </>
                        )}
                    </Col>
                </Row>
            ) : (
                <p>No data available.</p>
            )}
        </Modal>
    );
};

export default ModalBox;
